import { render } from "./ModalFamilyInvite.vue?vue&type=template&id=125c3bab&scoped=true"
import script from "./ModalFamilyInvite.vue?vue&type=script&lang=js"
export * from "./ModalFamilyInvite.vue?vue&type=script&lang=js"

import "./ModalFamilyInvite.vue?vue&type=style&index=0&id=125c3bab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125c3bab"]])

export default __exports__